<template>

    <div  style="height:40px;border-bottom:solid 1px #e0dddd;">
      <el-row justify="space-between" style="margin-top: 5px;" >
        <el-col :span="8" style="padding-left: 10px" v-if="openDetail === true">
          <div @click="goBack">
            <el-icon style="font-size: 30px;color: #409eff">
              <ArrowLeft/>
            </el-icon>
          </div>
        </el-col>
        <el-col :span="8" style="padding-left: 10px" v-if="openDetail === false">
          <el-button type="primary" plain @click="getCurrentPrc">刷新</el-button>
        </el-col>
        <el-col :span="8" style="font-size: 20px;text-align: center">
          <b>{{ '试产验证流转单' }}</b>
        </el-col>
        <el-col :span="8" style="color:#409eff;">
          <el-row justify="end" style="align-items: center">
            <div style="border:solid 1px #e0dddd;padding: 4px;"> <b>当前用户:{{ user.full_name }}</b></div>
            <el-button plain type="primary" @click="closeWeb" style="margin: 0 10px">退出</el-button>
          </el-row>
        </el-col>
      </el-row>
    </div>

    <div v-if="openDetail === false" class="sub-div" >
      <div v-if="currentPrcLogList === null || currentPrcLogList.length === 0">
        <el-row justify="center" style="font-size: 40px;margin-top: 30px">{{ '暂无需要处理的流程' }}</el-row>
      </div>
      <div v-else style="padding-bottom: 30px" >
        <div v-for="(prcItem, index) in currentPrcLogList"
             style="border:solid 1px #e0dddd;padding: 5px 10px 0 0;margin: 8px;">
          <div style="margin-left: 10px">{{index + 1 + '、'}}</div>
          <el-form label-width="110px" size="small" >
            <el-form-item label="流程编号：">
              <el-input v-model="prcItem.process_id" clearable  placeholder="流程编号" filterable disabled style="width: 80%;" />
              <el-button @click="showPrcItem(prcItem)" style="margin-left: 12px" type="primary">填写试模记录</el-button>
            </el-form-item>
            <el-form-item  label="项目/产品名称：">
              <el-input v-model="prcItem.pro_name" clearable placeholder="项目/产品名称" filterable disabled/>
            </el-form-item>
            <el-row >
              <el-form-item label="材料名称：" style="width: 50%">
                <el-input v-model="prcItem.material_name"  disabled/>
              </el-form-item>
              <el-form-item label="材料颜色：" style="width: 50%">
                <el-input v-model="prcItem.material_color"  disabled/>
              </el-form-item>
            </el-row>
            <el-form-item label="牌号：">
              <el-input v-model="prcItem.shop_no" disabled/>
            </el-form-item>
            <el-form-item label="批号：">
              <el-input v-model="prcItem.batch_no" disabled/>
            </el-form-item>
            <el-row >
              <el-form-item label="模具编号：" style="width: 50%">
                <el-input v-model="prcItem.mold_id"  disabled/>
              </el-form-item>
              <el-form-item label="计划产出(pcs)：" style="width: 50%">
                <el-input v-model="prcItem.pcs"  disabled/>
              </el-form-item>
            </el-row>
            <el-row >
              <el-form-item label="模具穴数：" style="width: 50%">
                <el-input v-model="prcItem.cavity"  disabled/>
              </el-form-item>
              <el-form-item label="需求日期：" style="width: 50%">
                <el-input v-model="prcItem.need_date"  disabled/>
              </el-form-item>
            </el-row>
          </el-form>
        </div>
      </div>
    </div>

    <div v-if="openDetail === true" class="sub-div">
      <PrcMobileApp2 :prcItem="prcItem"  @goBack="goBack"/>
    </div>

</template>

<script>
import {ArrowLeft} from "@element-plus/icons-vue";
import PrcMobileApp2 from "@/views/mobile/prc/PrcMobileApp2.vue";

export default {
  name: "PrcMobileApp1",
  components: {PrcMobileApp2, ArrowLeft},
  props: {},
  data() {
    return {
      pageWidth: window.innerWidth,
      pageHeight: window.innerHeight,

      openDetail: false,
      currentPrcLogList:[],
      prcItem:{}
    };
  },
  computed: {
    user() {
      return this.$store.state.core.currentUser;
    },
  },
  created() {
    this.getCurrentPrc()
  },
  mounted() {
    //动态获取页面宽度
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {

    //动态获取屏幕宽度
    handleResize() {
      this.pageWidth = window.innerWidth;
      this.pageHeight = window.innerHeight;
    },

    //退出系统方法
    async closeWeb() {
      await this.$http('frameLoginService.logout')
      this.$store.commit('core/LOGOUT');
      this.$router.push('/loginMobile1')
    },

    //获取带我处理的试产验证流转单
    async getCurrentPrc(){

      this.currentPrcLogList = await this.$http('prcMobileAppService.getCurrentPrc', {user_id: this.user.id})
    },

    //跳转操作页
    showPrcItem(prcItem){
      this.openDetail = true;
      this.prcItem = prcItem;
    },

    //返回上一页面
    goBack() {
      this.openDetail = false;
    },

  }
}
</script>

<style lang="less" scoped>

:deep(.el-form-item){
  margin-bottom: 8px;
}

.sub-div {
  overflow: auto;
  width: 100%;
  height: calc(100% - 40px);

}

</style>